export function safeParse<T>(str: string | null | undefined): T | undefined {
	if (!str) return undefined;
	try {
		return JSON.parse(str) as T;
	} catch (e) {
		// TODO: Should malformed string be handled better?
		// This choice will ultimately lead to lost input
		// once the user saves on the next step of SAP flow
		return undefined;
	}
}
